import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'inline-group',
  imports: [],
  template: '<ng-content></ng-content>',
  styleUrl: './inline-group.component.scss',
  host: {
    '[style.gap]': '_gap()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineGroupComponent {
  /** Accepts `0.75`, `'12px'`, `'1rem'`, defaults rem */
  gap = input<number | string>(1.76);
  private _gap = computed(() => {
    const val = this.gap();
    return typeof val === 'number' ? `${val}rem` : String(val);
  });
}
